import React, { useEffect, useReducer, useRef, ReactNode  } from "react";

// Interface for component props
interface SellingModuleProps {
	tools?: boolean;
	hidden?: boolean;
	children?: ReactNode;
}

export const SellingModule = ( props: SellingModuleProps ) => {

	return(
		<div className={"selling-module" + (props.tools ? " mb-selling-module": "") + (props.hidden ? " hidden": "")}>
			{props.children}
		</div>
	);
};